import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';

/* CSS */
import shared from './styles/shared.module.css';

/* Header and footer */
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';

/* Context */
import { AuthProvider } from './context/AuthContext';
import { ToastProvider } from './context/ToastContext';

/* Authentication */
import ProtectedRoute from './components/auth/ProtectedRoute';

/* Pages */
import AboutPage from './pages/AboutPage';
import HelpPage from './pages/HelpPage';
import HomePage from './pages/HomePage';
import MyTripsPage from './pages/MyTripsPage';
import SettingsPage from './pages/SettingsPage';
import TripsSummaryPage from './pages/TripsSummaryPage';
import CostBreakdownPage from './pages/CostBreakdownPage';
import NewTripPage from './pages/NewTripPage';
import JoinTripPage from './pages/JoinTripPage';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import CheckEmailPage from './pages/CheckEmailPage';
import PasswordSetupPage from './pages/PasswordSetupPage';
import ProfileSetupPage from './pages/ProfileSetupPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';

/* Layout Wrapper to keep Header/Footer persistent */
const Layout = () => {
    return (
        <div className='app-container'>
            <Header />
            <main className={shared.mainContent}>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

/* The Router Configuration */
const router = createBrowserRouter([
    {
        path: "/",
        element: (
            <ProtectedRoute>
                <Layout />
            </ProtectedRoute>
        ),
        children: [
            { path: "/", element: <HomePage /> },
            { path: "/trips", element: <MyTripsPage /> },
            { path: "/summary", element: <TripsSummaryPage /> },
            { path: "/cost/:id", element: <CostBreakdownPage /> },
            { path: "/about", element: <AboutPage /> },
            { path: "/help", element: <HelpPage /> },
            { path: "/settings", element: <SettingsPage /> },

            /* CREATE Mode */
            { path: "/new", element: <NewTripPage /> },

            /* EDIT Mode */
            { path: "/trip/:id", element: <NewTripPage /> },

            /* Share link resolver */
            { path: "/join/:token", element: <JoinTripPage /> },
        ],
    },
    {
        path: "/login",
        element: <LoginPage />
    },
    {
        path: "/signup",
        element: <SignUpPage />
    },
    {
        path: "/forgotpassword",
        element: <ForgotPasswordPage />
    },
    {
        path: "/checkemail",
        element: <CheckEmailPage />
    },
    {
        path: "/resetpassword",
        element: <ResetPasswordPage />
    },
    {
        path: "/terms",
        element: <TermsPage />
    },
    {
        path: "/privacy",
        element: <PrivacyPage />
    },
    {
        path: "/passwordsetup",
        element: <PasswordSetupPage />
    },
    {
        path: "/profilesetup",
        element: <ProfileSetupPage />
    }
]);

const App = () => {
    return (
        <AuthProvider>
            <ToastProvider>
                <RouterProvider router={router} />;
            </ToastProvider>
        </AuthProvider>
    )
}

export default App;
